import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export default function SelectedItems(props) {
  const { t } = useTranslation("survey");
  useEffect(() => {
    //console.log(props.question.selectedItems);
    props.question.selectedItems.length = 1;
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  function removeAnswer(item) {
    props.question.value = props.question.value.filter((e) => e !== item.value);
  }

  function showSelectedItems(question) {
    const renderedItems = [];

    for (let i = 0; i < question.selectedItems.length; i++) {
      const item = question.selectedItems[i];
      const key = "sel" + i;
      /*
      const renderedItem = <SurveyQuestionCheckboxItem
          key={key}
          question={question}
          cssClasses={question.cssClasses}
          isDisplayMode={false}
          item={item}
          textStyle={null}
          isFirst={i === 0}
          index={i}
        />

        */
      const renderedItem = (
        <div className="sv_q_checkbox checked">
          <div key={key} className="sv_q_checkbox_label">
            <span>{item.text}</span>
            <button
              class="select2-selection__choice__remove"
              aria-label={`${t("survey.product_selection.remove")} ${
                item.text
              }`}
              onClick={() => removeAnswer(item)}
            >
              ×
            </button>
          </div>
        </div>
      );
      renderedItems.push(renderedItem);
    }
    return renderedItems;
  }

  const selectedCount = props.question.selectedItems.length;

  if (selectedCount === 0 && isOpen) setIsOpen(false);

  return (
    <div className="selected-items">
      <button
        aria-expanded={isOpen}
        aria-controls="selected-items"
        disabled={selectedCount === 0}
        onClick={() => {
          setIsOpen(selectedCount > 0 && !isOpen);
        }}
        className="product-selection__selected-btn link"
      >
        {t("survey.product_selection.selected")} ({selectedCount})
      </button>
      <div id="selected-items" className="selected-items__list">
        <fieldset className="sv_q_checkbox-left">
          {showSelectedItems(props.question)}
        </fieldset>
      </div>
    </div>
  );
}
